import React from "react";

import Page from "EmployeeApplication/Page";
import { useGetCurrentCompanyApplicationQuery, useUpdateCompanyApplicationMutation } from "EmployerApplication/api";
import ApplicationLayout from "EmployerApplication/Components/ApplicationLayout";
import { doneURL, documentUploadURL } from "EmployerApplication/urls";
import createDecorator from "final-form-focus";
import { Form } from "react-final-form";
import { useHistory } from "react-router-dom";
import AnalyticsTracking from "Utils/AnalyticsTracking";
import getTooltip from "Utils/getTooltip";
import { validateRequired, validateRoutingNumber, composeValidators } from "Utils/Validations";
import { BasicLoading } from "ZeroRuby";

import { CardSection } from "Common/Card";
import { SIFormRadioGroup, SIFinalFormField } from "Common/forms";
import { Row } from "Common/Grid";
import InfoPopover from "Common/InfoPopover";
import NavigationControls from "Common/NavigationControls";

const focusOnErrors = createDecorator();

const autoPayLabel = (
  <div>
    Do you want SimplyInsured to set up auto pay for future payments?
    <InfoPopover infoTitle="Leigh Says..." infoText={getTooltip("Auto Pay")} className="AddPaymentInformation__toolTip" placement="bottom" />
  </div>
);

const PaymentInformation = () => {
  const history = useHistory();
  const { data: companyApplication, isLoading } = useGetCurrentCompanyApplicationQuery();
  const companyPolicyId = companyApplication?.id;
  const [updateCompanyApplication] = useUpdateCompanyApplicationMutation();

  if (isLoading) return <BasicLoading />;

  const { bankName, bankRoutingNumber, bankAccountNumber, bankAutoPay, offersAutopay } = companyApplication;

  const initialValues = {
    bankName,
    bankRoutingNumber,
    bankAccountNumber,
    bankAutoPay,
  };

  const submitHandler = async (values) => {
    AnalyticsTracking.trackEvent("payment_information_save_clicked", {});
    try {
      await updateCompanyApplication({
        id: companyPolicyId,
        bank_account_number: values.bankAccountNumber,
        bank_name: values.bankName,
        bank_routing_number: values.bankRoutingNumber,
        bank_auto_pay: values.bankAutoPay,
      });

      history.push(doneURL);
    } catch (error) {
      console.warn("Unable to save payment information.");
    }
  };

  return (
    <Page title="Payment Information">
      <Form onSubmit={submitHandler} decorators={[focusOnErrors]} initialValues={initialValues}>
        {({ handleSubmit, submitting }) => (
          <form onSubmit={handleSubmit}>
            <CardSection>
              <Row>
                <SIFinalFormField label="Bank Name" name="bankName" validate={validateRequired} sm={4} />
              </Row>
              <Row>
                <SIFinalFormField
                  label="Routing Number"
                  name="bankRoutingNumber"
                  validate={composeValidators(validateRequired, validateRoutingNumber)}
                  sm={4}
                />
              </Row>
              <Row>
                <SIFinalFormField label="Account Number" name="bankAccountNumber" validate={validateRequired} sm={4} />
              </Row>
              {offersAutopay && (
                <Row>
                  <SIFinalFormField name="bankAutoPay" label={autoPayLabel} component={SIFormRadioGroup} validate={validateRequired} />
                </Row>
              )}
            </CardSection>
            <NavigationControls backLink={documentUploadURL} submitting={submitting} />
          </form>
        )}
      </Form>
    </Page>
  );
};

export default PaymentInformation;
